import { AxiosInstance } from "axios";

import { getClient } from "../axios";

import {
    CityMultiLingualDTO,
    CityWithStreetsDTO,
    CodeValuePair,
    RiskDTO,
} from "./address.types";

/**
 * Service class for managing address related operations.
 */

class AddressService {
    /**
     * HTTP client instance for making requests.
     */
    public client: AxiosInstance;

    /**
     * Base path for address-related API endpoints.
     */
    private basePath = "address";

    constructor() {
        this.client = getClient();
    }

    /**
     * Constructs the full API endpoint path.
     * @param path - The specific endpoint path to append to the base path.
     * @returns The full API endpoint path.
     */
    private getFullPath(path = ""): string {
        return `${this.basePath}${path}`;
    }

    public getAllCities(filter?: string) {
        return this.client
            .get<CityMultiLingualDTO[]>(this.getFullPath("/cities"), {
                params: {
                    filter,
                },
            })
            .then((result) => result.data);
    }

    public getStreet(cityId: string, streetName?: string) {
        return this.client
            .get<CityWithStreetsDTO[]>(
                this.getFullPath(`/cities/${cityId}/streets`),
                {
                    params: {
                        streetName,
                    },
                },
            )
            .then((result) => result.data);
    }

    public getCountries(language: string) {
        return this.client
            .get<CodeValuePair[]>(this.getFullPath("/countries"), {
                params: {
                    language,
                },
            })
            .then((result) => result.data);
    }

    public getNationalities(language: string) {
        return this.client
            .get<CodeValuePair[]>(this.getFullPath("/nationalities"), {
                params: {
                    language,
                },
            })
            .then((result) => result.data);
    }

    public getRisk(streetId?: string, houseNumber?: string) {
        return this.client
            .get<RiskDTO>(this.getFullPath("/risk-scorings"), {
                params: {
                    streetId,
                    houseNumber,
                },
            })
            .then((result) => result.data);
    }
}

export const addressService = new AddressService();
